"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WrappedPropertyArray = void 0;
const vue_1 = require("vue");
const functions_1 = require("./functions");
const WrappedPropertyArrayItem_1 = require("./WrappedPropertyArrayItem");
const WrappedPropertyBase_1 = require("./WrappedPropertyBase");
const WrappedPropertyCtor_1 = require("./WrappedPropertyCtor");
const aggregateFunction_1 = require("../JSchema/aggregateFunction");
const calcFunction_1 = require("../JSchema/calcFunction");
const defaultValue_1 = require("../JSchema/defaultValue");
const defineSchema_1 = require("../JSchema/defineSchema");
const fixData_1 = require("../JSchema/fixData");
const fixDateFormat_1 = require("../JSchema/fixDateFormat");
const getRuleMessage_1 = require("../JSchema/getRuleMessage");
const setData_1 = require("../JSchema/setData");
const setNewData_1 = require("../JSchema/setNewData");
const deepCopy_1 = require("../methods/deepCopy");
/**
 * obiekt reprezentujący tablicę danych
 *
 * @export
 * @class WrappedPropertyArray
 * @extends {WrappedPropertyBase<IArrayInternal>}
 * @implements {IWrappedProperty}
 */
class WrappedPropertyArray extends WrappedPropertyBase_1.WrappedPropertyBase {
    // export class WrappedPropertyArray<ModelType extends Array<any> = any> extends WrappedPropertyBase<IArrayInternal, ModelType> implements IWrappedProperty<ModelType> {
    constructor(props) {
        var _a, _b, _c, _d, _e, _f;
        let mlength = 0;
        const schema = props.schema;
        const options = props.options;
        const propName = props.propName;
        const parent = props.parent;
        super(props, (internal) => {
            internal.schitems = schema.items;
            // internal.subitemcache = [];
            internal.cachedKey = '';
            internal.cachedItems = [];
            // tworzenie tablicy
            mlength = internal.mparent.length;
            // internal.ntable = new Array(mlength) as WrapperPropertyArrayItem[];
            // sama tablica reaktywna, ale potem elementy są uznaczane przez markRaw
            internal.ntable = (0, vue_1.reactive)({
                table: []
            }).table;
        });
        const internal = this._internal;
        //guid field
        internal.guidField = '';
        if (((_a = schema.items) === null || _a === void 0 ? void 0 : _a.type) == 'object') {
            if ((_c = (_b = schema.items) === null || _b === void 0 ? void 0 : _b.properties) === null || _c === void 0 ? void 0 : _c.guid) {
                internal.guidField = 'guid';
            }
            else {
                for (const key in (_d = schema.items) === null || _d === void 0 ? void 0 : _d.properties) {
                    if (((_e = schema.items) === null || _e === void 0 ? void 0 : _e.properties[key].type) === 'string' && ((_f = schema.items) === null || _f === void 0 ? void 0 : _f.properties[key].format) === 'guid') {
                        internal.guidField = key;
                        break;
                    }
                }
            }
        }
        fullArray(this, internal);
        /*
    
        const prevArray = internal.prevModel;
        const foundIndexes: any = { length: 0 };
        // internal.ntable = new Array(mlength) as WrapperPropertyArrayItem[];
        for (let i = 0; i < mlength; i++) {
          let prevIndex = -1;
          if (prevArray) {
            if (internal.guidField) {
              let guid = internal.mparent[i][internal.guidField];
              if (guid) {
                // szukaj elementu w poprzedniej tablicy
                prevIndex = prevArray.findIndex((x: any) => x[internal.guidField] === guid);
    
              }
            } else {
              if (i < prevArray.length) {
                prevIndex = i;
    
              }
            }
            if (prevIndex > -1) {
              foundIndexes["" + prevIndex] = true;
              foundIndexes.length++;
            }
    
    
    
          }
    
          let obj = internal.ntable[i] = new WrapperPropertyArrayItem(
            this,
            internal.mparent,
            i,
            internal.schitems,
            internal.guidField,
            internal.options,
            prevArray,
            prevIndex
          );
          // Object.seal(obj);npm run test
    
    
          // return ssubitem as IWrapperPropertyArrayItem;
    
          // addRow(this, internal, internal.schitems, i);
        }
        // pozostałe
        if (prevArray && foundIndexes.length < prevArray.length) {
          let newIndex = internal.ntable.length;
          for (let i = 0; i < prevArray.length; i++) {
            if (!foundIndexes[i]) {
              let obj = internal.ntable[newIndex++] = new WrapperPropertyArrayItem(
                this,
                prevArray,
                i,
                internal.schitems,
                internal.guidField,
                internal.options,
                prevArray,
                -100
              );
            }
          }
        }
    
        */
        (0, functions_1.wrapSchemaProps)(this, internal, 'number', ['maxItems', 'minItems']);
        if (this.$schema.warnings) {
            (0, functions_1.wrapWarningProps)(this, internal, 'number', ['maxItems', 'minItems']);
        }
        // length
        let staticLength;
        if (schema.length !== undefined) {
            if (typeof schema.length !== 'number') {
                (0, functions_1.wrapSchemaProp)(this, 'length', internal, (newValue) => this.$setLength(newValue));
            }
            else {
                // przeniesie ustawienia length na sam dół poniżej inicjacji Vue
                staticLength = schema.length;
            }
        }
        // console.timeEnd('addRows wrapall:' + internal.options.wrapAll + ' (' + mlength + ')');
        // computed
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const self = this;
        const iwatch = (0, vue_1.watch)(() => (parent[propName] ? parent[propName].length : 0), ( /*newValue: number*/) => {
            if (schema.debug) {
                // tslint:disable-next-line: no-debugger
                // debugger;
            }
            if (!self.$disabled) {
                self.$dirty = true;
            }
            if (self._internal.prevModel) {
                fullArray(this, this._internal);
            }
            else {
                syncArray(this, this._internal);
            }
        });
        internal.watchStops.push(iwatch);
        // potrzebne przeliczenia na starcie
        if (mlength && !self._options.disableCalculations && !self._options.wrapAll) {
            const needCalc = (0, functions_1.anyCalc)(internal.schitems);
            const props2 = internal.schitems.properties;
            if (needCalc && props2) {
                // są jakieś pola wymagające kalkulacji
                // $root,$parent,$parent2,$parent3,$external,$methods,$obj
                const paramCtx = {
                    $root: this.$root.$model,
                    $parent: internal.mparent,
                    $parent2: {},
                    $parent3: {},
                    $external: options.external,
                    $methods: options.schemaMethods,
                    $obj: {}
                };
                /*
                const paramdata: any[] = [
                  this.$root.$model,
                  internal.mparent,
                  {},
                  {},
                  options.external,
                  options.schemaMethods,
                  ,
                  null
                ];
                */
                if (props.dest) {
                    paramCtx.$parent2 = props.dest.$model;
                    if (props.dest.$parent) {
                        paramCtx.$parent3 = props.dest.$parent.$model;
                    }
                }
                //  let props = schitems.properties;
                for (const schkey of Object.keys(props2)) {
                    const schitem = props2[schkey];
                    if (schitem.calc) {
                        // const stime = new Date().getTime();
                        let thisModel;
                        let thisModelInternal;
                        let calcFunc;
                        if ((0, defineSchema_1.isFunction)(schitem.calc)) {
                            thisModelInternal = {
                                options: internal.options,
                                parent: {},
                                calcCtx: paramCtx
                            };
                            thisModel = (0, functions_1.createCtxProxy)(thisModelInternal);
                            calcFunc = schitem.calc;
                        }
                        else {
                            calcFunc = (0, calcFunction_1.calcFunction)(schitem, true, process.env.NODE_ENV !== 'production' && schitem.debug);
                        }
                        const $mparent = {
                            $parent: self,
                            $key: 0
                        };
                        paramCtx.$obj = {
                            $key: schkey,
                            $parent: $mparent,
                            $parent2: self,
                            $parent3: self.$parent,
                            $arrayIndex: 0,
                            _options: options
                        };
                        const basePath = self.$path;
                        for (; $mparent.$key < mlength; $mparent.$key++) {
                            paramCtx.$obj.$path = basePath + '[' + $mparent.$key + '].' + schkey;
                            paramCtx.$obj.$arrayIndex = $mparent.$key;
                            if (thisModelInternal) {
                                thisModelInternal.parent = internal.mparent[$mparent.$key];
                            }
                            try {
                                const res = calcFunc.call(thisModel || internal.mparent[$mparent.$key], paramCtx);
                                if (res !== undefined) {
                                    internal.mparent[$mparent.$key][schkey] = res;
                                }
                            }
                            catch (err) {
                                paramCtx.$obj.toString = () => '$.' + paramCtx.$obj.$path;
                                (0, functions_1.logError)(paramCtx.$obj, 'array item calc', err, schitem.calc);
                            }
                        }
                    }
                    else if (schitem.aggregate) {
                        const aggFunc = (0, aggregateFunction_1.aggregateFunction)(schitem, true, process.env.NODE_ENV !== 'production' && schitem.debug);
                        if (aggFunc) {
                            const $mparent = {
                                $parent: self,
                                $key: 0
                            };
                            paramCtx.$obj = {
                                $key: schkey,
                                $parent: $mparent,
                                $parent2: self,
                                $parent3: self.$parent,
                                _options: options
                            };
                            // for (let i = 0; i < mlength; i++) {
                            //  paramdata[6].$parent.$key = i;
                            for (; $mparent.$key < mlength; $mparent.$key++) {
                                try {
                                    const res = aggFunc.call(internal.mparent[$mparent.$key], paramCtx);
                                    // mparent[$mparent.$key][schkey] = res;
                                    internal.mparent[$mparent.$key][schkey] = res;
                                }
                                catch (err) {
                                    paramCtx.$obj.toString = () => '$.' + paramCtx.$obj.$path;
                                    (0, functions_1.logError)(paramCtx.$obj, 'array item aggregate', err, schitem.aggregate);
                                }
                            }
                        }
                    }
                }
            }
        }
        // initVue(this, this._internal);
        // już po stworzeniu Vue
        if (staticLength !== undefined) {
            this.$schema.length = staticLength;
            this.$setLength(staticLength); // tu jest sprawdzanie disabled wiec się nie przejmuję
        }
    }
    setValue(newValue) {
        var _a, _b, _c;
        if (Array.isArray(newValue)) {
            const enum1 = ((_a = this.$items[0]) === null || _a === void 0 ? void 0 : _a.$item.$schema.enum) || ((_c = (_b = this._internal.schema) === null || _b === void 0 ? void 0 : _b.items) === null || _c === void 0 ? void 0 : _c.enum);
            if (enum1 && Array.isArray(enum1)) {
                const nvalue = [...newValue];
                //console.log("array:haveEnum", JSON.stringify(enum1))
                for (let i = nvalue.length - 1; i >= 0; i--) {
                    if (enum1.indexOf(nvalue[i]) == -1) {
                        nvalue.splice(i, 1);
                    }
                }
                // if (JSON.stringify(nvalue) === JSON.stringify())
                newValue = nvalue;
            }
        }
        // console.log('array:setValue', JSON.stringify(newValue));
        super.setValue(newValue);
    }
    /**
     * sprawdza tablicę pod kątem błedów
     *
     * @param {*} [value] wejściowa tablica
     * @param {boolean} [skipDirty] czy ma nie zaznaczać pola jako dirty
     * @returns {(string | null)} komunikat błędu lub null gdy błedu nie ma
     * @memberof WrappedPropertyArray
     */
    $validate(value, skipDirty) {
        if (this.$disabled) {
            return null;
        }
        if (value === undefined) {
            value = this.$model;
        }
        if (!skipDirty) {
            this.$dirty = true;
        }
        if (value === undefined || value === null) {
            if (this.$schema.fieldRequired) {
                return (0, getRuleMessage_1.getRuleMessage)(this._internal, 'required', value, this.$schema);
            }
            else {
                return null;
            }
        }
        return super.$validate(value);
    }
    /**
     * sprawdza tablicę i wszystkie jej elementy pod kątem błędów
     *
     * @param {IWrappedProperty[]} result
     * @returns {IWrappedProperty[]} lista elementów zawierających błedy
     * @memberof WrappedPropertyArray
     */
    $validateAll(skipDirty, result) {
        if (result === undefined) {
            result = [];
        }
        if (this.$validate(undefined, skipDirty) !== null) {
            result.push(this);
        }
        // this.$dirty = true;  //przeniesiono do $validate()
        // tslint:disable-next-line: prefer-for-of
        for (let i = 0; i < this._internal.ntable.length; i++) {
            this._internal.ntable[i].$item.$validateAll(skipDirty, result);
        }
        return result;
    }
    /**
     * sprawdza tablicę pod kątem ostrzeżeń
     *
     * @param {*} [value] tablica
     * @param {boolean} [skipDirty] czy nie zaznaczać $dirty
     * @param {string[]} [checkResult]
     * @returns {string[]} lista ostrzeżeń lub pusta tablica
     * @memberof WrappedPropertyArray
     */
    $check(value, skipDirty, checkResult) {
        if (this.$schema.warnings && !this.$disabled) {
            if (value === undefined) {
                value = this.$model;
            }
            this.$dirty = true;
            checkResult = checkResult || [];
            if (value === undefined || value === null) {
                if (this.$schema.warnings.fieldRequired) {
                    checkResult.push((0, getRuleMessage_1.getWarningMessage)(this._internal, 'required', value, this.$schema));
                }
                return checkResult;
            }
            return super.$check(value, skipDirty, checkResult);
        }
        return (this.$checkResult = []);
    }
    /**
     * sprawdza tablicę i wszystkie jej elementy pod kątem ostrzeżeń
     *
     * @param {boolean} [skipDirty] czy nie zaznaczać $dirty
     * @param {IWrappedProperty[]} result
     * @returns {IWrappedProperty[]} lista pól zawierających ostrzeżenia
     * @memberof WrappedPropertyArray
     */
    $checkAll(skipDirty, result) {
        if (result === undefined) {
            result = [];
        }
        if (this.$check(undefined, skipDirty).length) {
            result.push(this);
        }
        // tslint:disable-next-line: prefer-for-of
        for (let i = 0; i < this._internal.ntable.length; i++) {
            this._internal.ntable[i].$item.$checkAll(skipDirty, result);
        }
        return result;
    }
    /**
     * funkcja ustawania danych na tablicy
     *
     * @param {*} value nowa tablica
     * @param {string} [path] ścieżka
     * @param {boolean} [fixArraySize] czy nowa długość tablicy ma odpowiadać tej nowo ustawianej,
     * dla false tablica się tylko rozszerza
     * @returns {boolean} czy udało się ustawić
     * @memberof WrappedPropertyArray
     */
    $setData(value, path, fixArraySize) {
        var _a, _b;
        // /Vue.set(parent, propName, value);
        let result = false;
        if (path) {
            result = (0, setData_1.setData)(this._internal.schema, this.$model, value, path, 0, fixArraySize, this._internal.options, this.$path);
        }
        else {
            let prevValue = undefined;
            if ((_a = this._options._anyEvent) === null || _a === void 0 ? void 0 : _a.beforeChange) {
                if (prevValue === undefined)
                    prevValue = (0, deepCopy_1.deepCopy)(this.$model);
                //if (newValue !== prevValue) {
                const event = { type: 'beforeChange', target: this, value, prevValue };
                if ((0, functions_1.runEvent)(event)) {
                    value = event.value;
                }
                //}
            }
            if ((_b = this._options._anyEvent) === null || _b === void 0 ? void 0 : _b.change) {
                if (prevValue === undefined)
                    prevValue = (0, deepCopy_1.deepCopy)(this.$model);
                if ((0, setData_1.setData)(this._internal.schema, this.$model, value, path, 0, fixArraySize, this._internal.options, this.$path)) {
                    // console.log('$setData', this.$path, value);
                    // if (prevValue !== value)
                    (0, functions_1.runEvent)({ type: 'change', target: this, value, prevValue });
                    result = true;
                }
                else {
                    result = false;
                }
            }
            else {
                result = (0, setData_1.setData)(this._internal.schema, this.$model, value, path, 0, fixArraySize, this._internal.options, this.$path);
            }
        }
        // let result = setData(this._internal.schema, this.$model, value, path, 0, fixArraySize, this._internal.options.longGuids);
        syncArray(this, this._internal);
        return result;
    }
    /**
     * funkcja ustawania nowych danych na tablicy
     *
     * @param {*} value nowa tablica
     * @param {string} [path] ścieżka
     * @returns {boolean} czy udało się ustawić
     * @memberof WrappedPropertyArray
     */
    $setNewData(value, path) {
        const result = (0, setNewData_1.setNewData)(this._internal.schema, this.$model, value, path, 0, this._internal.options);
        // jeśli length było wyliczalne to wylicz
        if (this.$schema.length !== undefined && typeof this._internal.schema.length !== 'number') {
            this.$setLength(this.$schema.length);
        }
        syncArray(this, this._internal);
        return result;
    }
    get $diffStatus() {
        if (this._internal.prevModel === undefined) {
            return 'new';
        }
        if (this._internal.prevModel.length !== this._internal.parent[this._internal.key.value].length)
            return 'changed';
        return '';
    }
    $getInvalidValues(res = []) {
        for (let i = 0; i < this._internal.ntable.length; i++) {
            // (this._internal.ntable[i] as WrapperPropertyArrayItem).$item.$getInvalidValues(res);
            // (this._internal.ntable[index1] as any)._cache.value;
            const ntableitem = this._internal.ntable[i];
            if (ntableitem._cache.value) {
                ntableitem._cache.value.$getInvalidValues(res);
            }
        }
        return res;
    }
    $setInvalidValues(res) {
        for (let i = 0; i < res.length; i++) {
            const child = this.$child(res[i].$path, true);
            if (child)
                child.$value = res[i].$value;
        }
    }
    /**
     * czyści status $dirty na wszystkich elementach tablicy
     *
     * @memberof WrappedPropertyArray
     */
    $reset() {
        // tslint:disable-next-line: prefer-for-of
        for (let i = 0; i < this._internal.ntable.length; i++) {
            this._internal.ntable[i].$reset();
        }
        super.$reset();
        // this.$dirty = false;
        // this.internal.vm.error = null;
    }
    /**
     * list elementów "dotkniętych" przez użytkownika
     *
     * @param {any[]} result
     * @returns {any[]}
     * @memberof WrappedPropertyArray
     */
    $dirtyList(result) {
        if (result === undefined) {
            result = [];
        }
        if (this.$schema.disabled)
            return result;
        if (this.$dirty)
            result.push(this);
        // tslint:disable-next-line: prefer-for-of
        for (let i = 0; i < this._internal.ntable.length; i++) {
            this._internal.ntable[i].$dirtyList(result);
        }
        return result;
    }
    $traverseFirst(predicate, allProps) {
        if (allProps) {
            if (predicate(this))
                return this;
            for (let i = 0; i < this._internal.ntable.length; i++) {
                const res = this._internal.ntable[i].$item.$traverseFirst(predicate, !!allProps);
                if (res)
                    return res;
            }
        }
        else {
            if (this.$schema.disabled)
                return undefined;
            if (predicate(this))
                return this;
            for (let i = 0; i < this._internal.ntable.length; i++) {
                const aitem = this._internal.ntable[i];
                if (aitem._cache.value) {
                    const res = aitem._cache.value.$traverseFirst(predicate, !!allProps);
                    if (res) {
                        return res;
                    }
                }
            }
        }
    }
    /**
     * naprawia format daty we wszytkich elementach tablicy
     *
     * @returns {number}
     * @memberof WrappedPropertyArray
     */
    $fixDateFormat() {
        return (0, fixDateFormat_1.fixDateFormat)(this._internal.schema, this.$model);
    }
    $fixFormat() {
        return (0, fixDateFormat_1.fixDateFormat)(this._internal.schema, this.$model);
    }
    /**
     * pobiera obudowane elementy tablicy
     *
     * @readonly
     * @memberof WrappedPropertyArray
     */
    get $items() {
        if (this._internal.items) {
            return this._internal.items.value;
        }
        else {
            return this._internal.ntable;
        }
    }
    /**
     * ustawienie liczby wierszy w tablicy
     *
     * @param {number} newLength nowa długośc tablicy
     * @returns {boolean} czy się udało ustawić
     * @memberof WrappedPropertyArray
     */
    $setLength(newLength) {
        if (this.$disabled) {
            return false;
        }
        if (newLength != undefined && typeof newLength === 'number' && !isNaN(newLength) && newLength >= 0) {
            const stable = this.$model;
            if (stable) {
                if (stable.length !== newLength) {
                    // usuwanie niepotrzebnych
                    while (stable.length > newLength) {
                        if (!this.$removeRow(stable.length - 1)) {
                            break; // nie da się usunąć
                        }
                    }
                    // dodawanie nowych
                    while (stable.length < newLength) {
                        if (!this.$addRow(undefined, newLength - stable.length)) {
                            break;
                        }
                    }
                }
                return stable.length === newLength;
            }
        }
        return false;
    }
    /**
     * funkcja dodania wiersza do tablicy
     *
     * @param {*} [nvalue] wartośc dodawanego elementu, można pominąć
     * @param {number} [count=1] ilośc dodawanych wierszy
     * @returns {boolean} czy się udało daodać
     * @memberof WrappedPropertyArray
     */
    $addRow(nvalue, count = 1) {
        var _a, _b;
        if (this.$disabled) {
            return false;
        }
        let mparent2 = this.$model;
        if (mparent2 === undefined) {
            // Vue.set(parent, propName, []);
            const defvalue = (0, defaultValue_1.defaultValue)(this._internal.schema, true, undefined, this._internal.options, this.$path);
            // console.log('recreate array',propName,defvalue);
            this.$setData(defvalue);
            // this.internal.Vue.set(this.internal.parent, this.propName, defvalue);
            mparent2 = this.$model;
        }
        if (mparent2) {
            // gdy jest ustawiona stała długość
            if (this.$schema.length !== undefined && mparent2.length === this.$schema.length) {
                return false;
            }
            this._internal.cachedKey = '';
            const startindex = mparent2.length;
            const schitems = this._internal.schitems;
            const tpath = this.$path;
            let nvalue2;
            if (schitems.type === 'object') {
                for (let i = 0; i < count; i++) {
                    nvalue2 = (0, defaultValue_1.defaultValue)(schitems, true, undefined, this._internal.options, tpath + '[' + (startindex + i) + ']');
                    if (nvalue) {
                        nvalue2 = Object.assign(nvalue2, nvalue);
                    }
                    mparent2.push(nvalue2);
                }
            }
            else {
                for (let i = 0; i < count; i++) {
                    if (nvalue !== undefined) {
                        nvalue2 = nvalue;
                    }
                    else {
                        nvalue2 = (0, defaultValue_1.defaultValue)(schitems, true, undefined, this._internal.options, tpath + '[' + (startindex + i) + ']');
                    }
                    mparent2[startindex + i] = nvalue2;
                }
            }
            if (this._internal.prevModel) {
                fullArray(this, this._internal);
                if ((_a = this._options._anyEvent) === null || _a === void 0 ? void 0 : _a.addRow) {
                    (0, functions_1.runEvent)({
                        type: 'addRow',
                        target: this,
                        value: startindex + count,
                        prevValue: mparent2[startindex + count]
                    });
                }
            }
            else {
                for (let i = 0; i < count; i++) {
                    addRow(this, this._internal, schitems, startindex + i);
                    if ((_b = this._options._anyEvent) === null || _b === void 0 ? void 0 : _b.addRow) {
                        (0, functions_1.runEvent)({
                            type: 'addRow',
                            target: this,
                            value: startindex + i,
                            // prevValue: startindex + i - 1
                            prevValue: mparent2[startindex + i]
                        });
                    }
                }
            }
        }
        //jeśli jest obsługa stronicowania to przeskocz na ostatnią stronę
        // this.pageNumber
        if (this._internal.vmUserData && this._internal.vmUserData['$pageNumber'] !== undefined) {
            this.$pageNumber = this.$pageCount - 1;
        }
        return true;
    }
    $removeRow(index) {
        var _a;
        if (this.$disabled) {
            return false;
        }
        //jesli to tryb porównania to blokuj usuwanie
        /*
        if (this._internal.prevModel) {
          return false;
        }
          */
        const modeltable = this.$model;
        // schematable.splice(index, 1);
        if (this.$schema.length !== undefined && modeltable && modeltable.length === this.$schema.length) {
            return false;
        }
        if (index === undefined) {
            index = this._internal.ntable.length - 1;
        }
        if (index < 0 || index >= this._internal.ntable.length) {
            return false;
        }
        //blokada przed uzunieciem wiersza który jest del
        // console.log('removeRow', index);
        if (this._internal.prevModel && this._internal.ntable[index].$diffStatus == 'del') {
            return false;
        }
        this._internal.cachedKey = '';
        if ((_a = this._options._anyEvent) === null || _a === void 0 ? void 0 : _a.removeRow) {
            (0, functions_1.runEvent)({
                type: 'removeRow',
                target: this,
                value: index
            });
        }
        const removed = this._internal.ntable.splice(index, 1);
        const l = this._internal.ntable.length;
        for (let i = index; i < l; i++) {
            // if (this._internal.prevModel && this._internal.ntable[i].$diffStatus === "del")
            //   break;
            this._internal.ntable[i].$setKey(i);
        }
        // usunąc cache
        removed[0].$clearCache();
        if (modeltable)
            modeltable.splice(index, 1); // bo na tym jest event ?
        return true;
    }
    $clearRow(index) {
        if (this.$disabled) {
            return false;
        }
        if (index === undefined) {
            index = this._internal.ntable.length - 1;
        }
        const nitem = (0, defaultValue_1.defaultValue)(this._internal.schitems, false, null, this._internal.options, this.$path + '[' + index + ']');
        this._internal.ntable[index].$clearCache();
        if (this.$model && nitem)
            this.$model[index] = nitem;
        return true;
    }
    /**
     * przesunięcie wierszy
     *
     * @param {number} index1 pierwszy indeks w tabeli
     * @param {number} index2 drugi indeks w tabeli
     * @returns {boolean} czy się udało zamienić
     * @memberof WrappedPropertyArray
     */
    $exchangeRow(index1, index2) {
        var _a;
        if (this.$disabled) {
            return false;
        }
        this._internal.cachedKey = '';
        const mparent = this.$model;
        if (mparent) {
            const item1 = mparent[index1];
            const item2 = mparent[index2];
            const cached1 = this._internal.ntable[index1]._cache.value;
            const dirtyList1 = cached1
                ? cached1.$dirtyList().map((x) => x.$path.substring(cached1.$path.length + 1))
                : [];
            this._internal.ntable[index1].$clearCache();
            const cached2 = this._internal.ntable[index2]._cache.value;
            const dirtyList2 = cached2
                ? cached2.$dirtyList().map((x) => x.$path.substring(cached2.$path.length + 1))
                : [];
            this._internal.ntable[index2].$clearCache();
            if ((_a = this._options._anyEvent) === null || _a === void 0 ? void 0 : _a.exchangeRow) {
                (0, functions_1.runEvent)({
                    type: 'exchangeRow',
                    target: this,
                    value: index2,
                    prevValue: index1
                });
            }
            mparent[index1] = item2;
            mparent[index2] = item1;
            //przenoszenie infomacji o dirty
            if (cached1) {
                const subitem1 = this._internal.ntable[index2].$item;
                subitem1.$setDirtyChild(dirtyList1);
            }
            if (cached2) {
                const subitem2 = this._internal.ntable[index1].$item;
                subitem2.$setDirtyChild(dirtyList2);
            }
            // jeśli jest obsługa stronicowania, to przeskocz na stronę gdzie jest nowy element
            if (this._internal.vmUserData && this._internal.vmUserData['$pageNumber'] !== undefined) {
                const newPage = Math.floor(index2 / this.$pageSize);
                if (newPage != this.$pageNumber) {
                    this.$pageNumber = newPage;
                }
            }
        }
        return true;
    }
    /**
     * przesunięcie wiersza do góry
     *
     * @param {number} index index wiersza, musi być większy od 0
     * @returns {boolean} czy się udało przesunąć
     * @memberof WrappedPropertyArray
     */
    $moveUp(index) {
        if (this.$disabled) {
            return false;
        }
        if (index === undefined) {
            index = this._internal.ntable.length - 1;
        }
        if (index > 0) {
            return this.$exchangeRow(index, index - 1);
        }
        return false;
    }
    /**
     * przesunięcie wiersza w dół
     *
     * @param {number} index indeks wiersza w tabeli, nie może to być ostatni wiersz
     * @returns {boolean} czy się udało
     * @memberof WrappedPropertyArray
     */
    $moveDown(index) {
        if (this.$disabled) {
            return false;
        }
        if (index === undefined) {
            index = 0;
        }
        if (this.$model && index < this.$model.length - 1) {
            return this.$exchangeRow(index, index + 1);
        }
        return false;
    }
    /**
     * sortowanie tablicy
     *
     * @param {string} field po jakim polu posortować
     * @returns
     * @memberof WrappedPropertyArray
     */
    $sort(field = '', desc = false) {
        if (this.$disabled) {
            return;
        }
        // let stime = new Date().getTime();
        this._internal.cachedKey = '';
        let v1 = -1;
        let v2 = 1;
        if (desc) {
            v1 = 1;
            v2 = -1;
        }
        if (field) {
            this._internal.mparent = this._internal.mparent.sort((a, b) => b[field] === a[field] ? 0 : b[field] > a[field] ? v1 : v2);
        }
        else {
            this._internal.mparent = this._internal.mparent.sort((a, b) => (b === a ? 0 : b > a ? v1 : v2));
        }
        // mparent = parent[propName] = narray;
        // destroy
        // clearCached();
        let index = this._internal.ntable.length;
        while (index--) {
            this._internal.ntable[index].$clearCache();
        }
        // tslint:disable-next-line: max-line-length
        // console.log('sorting', propName, field, new Date().getTime() - stime, mparent[0][field], mparent[mparent.length - 1][field]);
    }
    /**
     * zwraca częśc tablicy wg filtra
     *
     * @param {(value: any, index: number, array: any[]) => boolean} func filtr
     * @returns {any[]} filtrowana tablica
     * @memberof WrappedPropertyArray
     */
    $filter(func) {
        if (func) {
            return this._internal.ntable.filter(func);
        }
        return this._internal.ntable;
    }
    $setDisinctValue(value) {
        const prevValue = this.$model;
        if (prevValue && prevValue.indexOf(value) > -1)
            return false;
        const newValue = [...prevValue, value];
        this.setValue(newValue);
        return true;
    }
    /**
     * @deprecated używać $pageNumber
     * aktualny numer strony
     *
     * @type {number}
     * @memberof WrappedPropertyArray
     */
    get pageNumber() {
        return this.$pageNumber;
    }
    /**
     * aktualny numer strony
     *
     * @type {number}
     * @memberof WrappedPropertyArray
     */
    get $pageNumber() {
        return this.$getUserData('$pageNumber', 0);
        // return this.$data.pageNumber || 0;
    }
    /**
     * @deprecated uzywac $pageNumber
     * ustawienie numeru strony
     *
     * @memberof WrappedPropertyArray
     */
    set pageNumber(newValue) {
        this.$pageNumber = newValue;
    }
    /**
     * ustawienie numeru strony
     *
     * @memberof WrappedPropertyArray
     */
    set $pageNumber(newValue) {
        if (newValue < 0) {
            this.$setUserData('$pageNumber', 0);
            // this._options.Vue.set(this.$data, 'pageNumber', 0);
        }
        else if (newValue >= this.$pageCount) {
            (0, functions_1.logWarning)(this, `overflow pagenumber ${newValue} > ${this.$pageCount - 1}`, '');
            this.$setUserData('$pageNumber', this.$pageCount - 1);
            // this._options.Vue.set(this.obj.$data, 'pageNumber', this.pageCount - 1);
        }
        else {
            this.$setUserData('$pageNumber', newValue);
            // this._options.Vue.set(this.obj.$data, 'pageNumber', newValue);
        }
    }
    /**
     * @deprecated używac $pageSize
     * aktualny rozmiar strony
     *
     * @type {number}
     * @memberof WrappedPropertyArray
     */
    get pageSize() {
        return this.$pageSize;
        // return this.$data.pageSize;
    }
    /**
     * aktualny rozmiar strony
     *
     * @type {number}
     * @memberof WrappedPropertyArray
     */
    get $pageSize() {
        return this.$getUserData('$pageSize', 25);
        // return this.$data.pageSize;
    }
    /**
     * @deprecated używać $pageSize
     * ustawienie rozmiaru strony
     *
     * @memberof WrappedPropertyArray
     */
    set pageSize(newValue) {
        this.$pageSize = newValue;
    }
    /**
     * ustawienie rozmiaru strony
     *
     * @memberof WrappedPropertyArray
     */
    set $pageSize(newValue) {
        this.$setUserData('$pageSize', newValue);
        // this._options.Vue.set(this.$data, 'pageSize', newValue);
        if (this.pageNumber >= this.pageCount) {
            this.pageNumber = this.pageCount - 1;
        }
    }
    /**
     * @deprecated używać $pageCount
     * ilośc stron
     *
     * @readonly
     * @type {number}
     * @memberof WrappedPropertyArray
     */
    get pageCount() {
        return this.$pageCount;
    }
    /**
     * ilośc stron
     *
     * @readonly
     * @type {number}
     * @memberof WrappedPropertyArray
     */
    get $pageCount() {
        if (this.$schema.disabled || !this.$model) {
            return 0;
        }
        return Math.ceil(this.$model.length / this.$pageSize);
    }
    /**
     * @deprecated używać $order
     * sposób sortowania tablizy zwracanej przez $getItems
     *
     * @type {string}
     * @memberof WrappedPropertyArray
     */
    get order() {
        return this.$order;
    }
    /**
     * sposób sortowania tablizy zwracanej przez $getItems
     *
     * @type {string}
     * @memberof WrappedPropertyArray
     */
    get $order() {
        return this.$getUserData('$order', '');
    }
    /**
     * @deprecated używać $order
     * sposób sortowania tablizy zwracanej przez $getItems
     *
     * @memberof WrappedPropertyArray
     */
    set order(newValue) {
        this.$order = newValue;
        // this._options.Vue.set(this.$data, 'order', newValue);
    }
    /**
     * sposób sortowania tablizy zwracanej przez $getItems
     *
     * @memberof WrappedPropertyArray
     */
    set $order(newValue) {
        this.$setUserData('$order', newValue);
        // this._options.Vue.set(this.$data, 'order', newValue);
    }
    /**
     * pobranie częsciowej tablicy
     *
     * @param {number} [start] indeks startowy elementu
     * @param {number} [count] ile elementów
     * @param {string} [order] pole po którym jest sortowanie 'polse desc'
     * @returns
     * @memberof WrappedPropertyArray
     */
    $getItems(start, count, order) {
        const mparent2 = this.$model;
        if (!mparent2) {
            return [];
        }
        start = start || 0;
        /*
        if (count && this.$pageSize !== count) {
          // console.log('set pageSize', count);
          this.$pageSize = count;
        }
          */
        let end = count;
        if (end === undefined) {
            end = mparent2.length;
        }
        else {
            end += start;
            if (end >= mparent2.length) {
                end = mparent2.length;
            }
        }
        // const stime = new Date().getTime();
        let res = [];
        const nkey = `${start}|${end}|${order}`;
        if (nkey === this._internal.cachedKey) {
            return this._internal.cachedItems;
        }
        if (order) {
            const otable = Array.from(this._internal.ntable);
            //let desc = false;
            let orderField = order;
            let gvalue = -1;
            if (orderField.endsWith(' desc')) {
                // desc = true;
                orderField = orderField.substring(0, order.length - 5);
                gvalue = 1;
            }
            if (orderField.startsWith('-')) {
                // desc = true;
                orderField = orderField.substring(1);
                gvalue = 1;
            }
            otable.sort((a, b) => mparent2[b.$key][orderField] === mparent2[a.$key][orderField]
                ? 0
                : mparent2[b.$key][orderField] > mparent2[a.$key][orderField]
                    ? gvalue
                    : -gvalue);
            res = otable.slice(start, end).map((x) => x.$item);
            /*
            for (let i = start; i < (end as number); i++) {
              res.push(otable[i].$item);
            }
              */
        }
        else {
            res = this._internal.ntable.slice(start, end).map((x) => x.$item);
            /*
            for (let i = start; i < (end as number); i++) {
              res.push(this._internal.ntable[i].$item);
            }
              */
        }
        this._internal.cachedItems = res;
        this._internal.cachedKey = nkey;
        return res;
    }
    /**
     * pobranie strony
     *
     * @param {number} page numer strony
     * @param {number} [pageSize=25] rozamiar strony
     * @returns
     * @memberof WrappedPropertyArray
     */
    $getPage(page, pageSize, order) {
        if (page == undefined)
            page = this.$pageNumber;
        if (pageSize == undefined)
            pageSize = this.$pageSize;
        if (order == undefined)
            order = this.$order;
        return this.$getItems(page * pageSize, pageSize, order);
    }
    /**
     * wyczyszenie cache elementów tablicy
     *
     * @memberof WrappedPropertyArray
     */
    $destroy() {
        clearCached(this._internal);
        super.$destroy();
    }
    /**
     * tytuł subpola
     * @param fieldName
     */
    $fieldTitle(fieldName) {
        return this.$tableField(fieldName, (x) => x.$title);
        /*
        if (this.$items.length) {
          let item: IWrappedProperty;
          if (this._internal.schema.items!.type == 'object' && fieldName) {
            if (isFunction(fieldName)) {
              item = fieldName(this.$items[0].$item);
            } else {
              item = (this.$items[0].$item as any)[fieldName]
            }
          } else {
            item = this.$items[0].$item;
          }
          if (item) {
            return item.$title;
          }
        }
        return this.$tableField(fieldName, x => x.$title) || "";
    */
        /*
        let result = "";
        if (this._internal.schema.items) {
          let field: JSONSchema;
          if ((this._internal.schema.items.type == 'object' || this._internal.schema.items.properties) && fieldName) {
            if (isFunction(fieldName))
              field = fieldName(this._internal.schema.items!.properties!);
            else
              field = this._internal.schema.items!.properties![fieldName];
          } else {
            field = this._internal.schema.items;
          }
          if (field && field.title) {
    
            if (typeof field.title === "string")
              result = field.title;
            else {
    
              if (field.cache === undefined) {
                field.cache = {};
              }
              let ff = field.cache[`schema_title`];
              if (ff === undefined) {
                ff = validPropFunction(field.title);
                // console.log('calc func', ff.toString());
                field.cache[`schema_title`] = ff;
              }
              var smodel = defaultValue(this._internal.schema.items, true);
              result = ff.apply(smodel, [this.$root.$model, null, null, null, this._options.external ?? {}, this._options.schemaMethods, this]);
    
    
    
            }
            if (result) {
              result = this._options._i18n ? this._options._i18n.value.t(result) : result
            }
    
          }
    
    
    
        }
        return result;
    */
    }
    /**
     * tytuł subpola
     * @param fieldName
     */
    $tableField(fieldName, fieldProp) {
        let item;
        if (this.$items.length) {
            delete this._internal._cachedSubItems;
            if (this._internal.schema.items.type == 'object' && fieldName) {
                if (typeof fieldName === 'string') {
                    item = this.$items[0].$item[fieldName];
                }
                else {
                    item = fieldName(this.$items[0].$item);
                }
            }
            else {
                item = this.$items[0].$item;
            }
        }
        else if (this._internal.schema.items) {
            let subItems = this._internal._cachedSubItems;
            if (!subItems) {
                const ttype = this._internal.schema.items.type || 'object';
                subItems = new WrappedPropertyCtor_1.WrappedPropertyCtor[ttype]({
                    dest: this,
                    parent: [],
                    propName: 0,
                    schema: this._internal.schema.items,
                    options: Object.assign({}, this._options, {
                        disableCalculations: true,
                        wrapAll: false,
                        disableValidations: true
                    })
                });
                this._internal._cachedSubItems = subItems;
            }
            if (fieldName) {
                if (typeof fieldName === 'string') {
                    item = subItems[fieldName];
                }
                else {
                    item = fieldName(subItems);
                }
            }
            else {
                item = subItems;
            }
        }
        if (fieldProp && item) {
            if ((0, defineSchema_1.isFunction)(fieldProp)) {
                return fieldProp(item);
            }
            else {
                return item[fieldProp];
            }
        }
        return item;
    }
    /**
     * zdarzenie przed zmianą ścieżki
     *
     * @protected
     * @memberof WrappedPropertyBase
     */
    beforePathChange() {
        super.beforePathChange();
        // tslint:disable-next-line: prefer-for-of
        for (let i = 0; i < this._internal.ntable.length; i++) {
            this._internal.ntable[i].beforePathChange();
        }
    }
    /**
     * zdarzenie po zmianie ścieżki
     *
     * @protected
     * @memberof WrappedPropertyBase
     */
    afterPathChange() {
        // tslint:disable-next-line: prefer-for-of
        for (let i = 0; i < this._internal.ntable.length; i++) {
            this._internal.ntable[i].afterPathChange();
        }
        super.afterPathChange();
    }
}
exports.WrappedPropertyArray = WrappedPropertyArray;
/**
 * dodanie wiersza do tablicy
 *
 * @param {WrappedPropertyArray} self obiekt repezentujący tablicę
 * @param {IArrayInternal} internal dane wewnętrzne obiektu
 * @param {*} schitems schemat pola
 * @param {number} rowIndex indeks dodwanago wiersza
 * @returns {IWrapperPropertyArrayItem} obudowany element tablicy
 */
function addRow(self, internal, schitems, rowIndex) {
    const ssubitem = new WrappedPropertyArrayItem_1.WrapperPropertyArrayItem(self, internal.parent[internal.key.value], rowIndex, schitems, internal.guidField, internal.options);
    // Object.seal(ssubitem);
    internal.ntable.push(ssubitem);
    return ssubitem;
}
/**
 * usunięcie cache wszystkich elementów tablicy
 *
 * @param {IArrayInternal} internal
 */
function clearCached(internal, startIndex = 0) {
    // tslint:disable-next-line: prefer-for-of
    for (let i = startIndex; i < internal.ntable.length; i++) {
        internal.ntable[i].$clearCache();
    }
}
/**
 * synchrownizacja tabeli z®odłowej z obudowaną
 * @param self
 * @param internal
 */
function syncArray(self, internal) {
    const smodel = self.$model;
    if (!smodel) {
        if (internal.ntable.length) {
            clearCached(internal);
            internal.ntable.length = 0;
        }
        return internal.ntable;
    }
    const l = smodel.length;
    // console.log('mparent.length', mparent.length);
    if (l > internal.ntable.length) {
        // console.log('autogrow', l, ntable.length);
        while (internal.ntable.length < l) {
            (0, fixData_1.fixData)(internal.schitems, smodel[internal.ntable.length], false, internal.options);
            addRow(self, internal, internal.schitems, internal.ntable.length);
        }
    }
    else if (l < internal.ntable.length) {
        clearCached(internal, l);
        internal.ntable.length = l;
    }
    return internal.ntable;
}
/**
 * stworzenie na nowo całej tablicy obudowanej
 * @param self
 * @param internal
 */
function fullArray(self, internal) {
    //clear cache
    for (let i = 0; i < internal.ntable.length; i++)
        clearCached(internal, i);
    internal.ntable.length = 0;
    const mlength = internal.mparent.length;
    const prevArray = internal.prevModel;
    const foundIndexes = { length: 0 };
    // internal.ntable = new Array(mlength) as WrapperPropertyArrayItem[];
    for (let i = 0; i < mlength; i++) {
        let prevIndex = -1;
        if (prevArray) {
            if (internal.guidField) {
                const guid = internal.mparent[i][internal.guidField];
                if (guid) {
                    // szukaj elementu w poprzedniej tablicy
                    prevIndex = prevArray.findIndex((x) => x[internal.guidField] === guid);
                }
            }
            else {
                if (i < prevArray.length) {
                    prevIndex = i;
                }
            }
            if (prevIndex > -1) {
                foundIndexes['' + prevIndex] = true;
                foundIndexes.length++;
            }
        }
        internal.ntable[i] = new WrappedPropertyArrayItem_1.WrapperPropertyArrayItem(self, internal.mparent, i, internal.schitems, internal.guidField, internal.options, prevArray, prevIndex);
        // Object.seal(obj);npm run test
        // return ssubitem as IWrapperPropertyArrayItem;
        // addRow(this, internal, internal.schitems, i);
    }
    // pozostałe
    if (prevArray && foundIndexes.length < prevArray.length) {
        let newIndex = internal.ntable.length;
        for (let i = 0; i < prevArray.length; i++) {
            if (!foundIndexes[i]) {
                internal.ntable[newIndex++] = new WrappedPropertyArrayItem_1.WrapperPropertyArrayItem(self, prevArray, i, internal.schitems, internal.guidField, internal.options, prevArray, -100);
            }
        }
    }
}
WrappedPropertyCtor_1.WrappedPropertyCtor.array = WrappedPropertyArray;
exports.default = WrappedPropertyArray;
//# sourceMappingURL=WrappedPropertyArray.js.map